import authRoutes from 'src/services/@core/API/routes/auth'
import userRoutes from 'src/services/@core/API/routes/user'
import companyRoutes from 'src/services/@core/API/routes/company'
import patientRoutes from 'src/services/@core/API/routes/patients'
import chatRoutes from 'src/services/@core/API/routes/chats'
import adminRoutes from 'src/services/@core/API/routes/admin'

export default {
  ...authRoutes,
  ...companyRoutes,
  ...patientRoutes,
  ...userRoutes,
  ...chatRoutes,
  ...adminRoutes
}
